module.exports = __webpack_public_path__ + "img/xinzhuang-2.d04dabb1.jpg";